<template><section><template>
<h2>文本框</h2>
<div class="bs-docs-section">
  <div class="bs-example">
   <n3-textarea v-model="value"></n3-textarea>
  </div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-textarea</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-textarea</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>resize</td>
<td><code v-pre="">boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否支持拖动</td>
</tr>
<tr>
<td>max-length</td>
<td><code v-pre="">Number</code></td>
<td>-</td>
<td>字符数限制</td>
</tr>
<tr>
<td>max-height</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>最大高度</td>
</tr>
<tr>
<td>min-height</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>最小高度</td>
</tr>
</tbody>
</table>
<h3>事件</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>失焦</td>
</tr>
<tr>
<td>focus</td>
<td>聚焦</td>
</tr>
<tr>
<td>change</td>
<td>值变化</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
      value: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TextareaDocs.md?126ff986